import React from "react";
import Chart from "react-apexcharts";
import { useSelector } from "react-redux";

const FloodImpactChart = () => {
  const floodImpactFilter = useSelector(
    (state) => state.dashboard?.floodImpactGraphCount
  );

  const series = [
    floodImpactFilter.noDamage || 0,
    floodImpactFilter.minorDamage || 0,
    floodImpactFilter.repair || 0,
    floodImpactFilter.noRepair || 0,
  ];

  const chartOptions = {
    chart: {
      type: "bar",
      toolbar: { show: false },
      animations: { enabled: true, easing: "easeout", speed: 600 },
    },
    plotOptions: {
      bar: {
        horizontal: false, // Changed to vertical
        distributed: true,
        borderRadius: 6,
        barHeight: "50%",
      },
    },
    dataLabels: {
      enabled: true,
      style: { colors: ["#fff"] },
      formatter: (val) => val,
    },
    xaxis: {
      categories: [
        "No Damage",
        "Minor Damage",
        "Damaged but Repaired",
        "Damaged & Not Repaired",
      ],
      labels: {
        style: { fontSize: "14px", colors: "#555" },
      },
    },
    yaxis: {
      title: { text: "" },
      labels: { style: { fontSize: "14px", colors: "#555" } },
    },
    colors: ["#10b981", "#3b82f6", "#f59e0b", "#ef4444"],
    grid: { show: false },
    tooltip: { y: { formatter: (val) => `${val} households` } },
  };

  const chartSeries = [{ data: series }];

  return (
    <div className="bg-white p-6 rounded-lg  max-w-3xl mx-auto">
      <h3 className="text-xl my-2 p-0 text-[#3A3A3A] font-bold uppercase text-center text-balance">
        Flood Impact on Water Sources
      </h3>
      <Chart
        options={chartOptions}
        series={chartSeries}
        type="bar"
        height={350}
      />
    </div>
  );
};

export default FloodImpactChart;
